import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addEdgeToDecisionTreePath } from '../../../../actions/searchActions';
import { getBrandOfSelectedTicket, getSimplrAccountIdOfSelectedTicket } from '../../../../extractFromState';
import { getRBIStoreLocationQuery } from '../../../../selectors/tools';
import { Title, NoResultsWrapper } from '../../NodeGroups/DTOrderSearch/DTOrderSearch.styles';
import NoStoreSearchResults from './NoStoreSearchResults/NoStoreSearchResults';
import DTSearchView from 'components/DecisionTree/Common/DTSearchView/DTSearchView';
import { StoreSearchResults } from './StoreSearchResults/StoreSearchResults';
import { getRbiStores, rbiSetStoreLocationQuery } from 'actions/tools/RBIActions';
import { getStoreSearchProperties, getSelectedRbiStore } from '../../../../selectors/tools';
import { SEARCH_RBI_STORES } from 'constants/searchTypes';

const DTRBIStoreLocationSearchNode = () => {
  const dispatch = useDispatch();

  const simplrAccountPtrId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const brandName = useSelector(getBrandOfSelectedTicket);
  const isNextButtonActive = useSelector(getSelectedRbiStore);
  const stores = useSelector(getStoreSearchProperties);
  const locationSearchQuery = useSelector(getRBIStoreLocationQuery);

  const fetchLocationsFromSearch = useCallback(async () => {
    const locationSearchPayload = {
      searchTerm: locationSearchQuery,
      brandName,
      simplrAccountId: simplrAccountPtrId,
    };

    await dispatch(getRbiStores(locationSearchPayload));
  }, [locationSearchQuery, brandName, simplrAccountPtrId, dispatch]);

  useEffect(() => {
    if (locationSearchQuery) {
      fetchLocationsFromSearch();
    }
  }, [locationSearchQuery, fetchLocationsFromSearch]);

  const handleNextButtonClick = () => dispatch(addEdgeToDecisionTreePath('store_selected'));

  const handleSearchSubmit = (value) => {
    dispatch(rbiSetStoreLocationQuery(value));
  };

  return (
    <DTSearchView
      isNextButtonActive={isNextButtonActive}
      onNextButtonClick={handleNextButtonClick}
      handleSearchSubmit={handleSearchSubmit}
      searchType={SEARCH_RBI_STORES}
      searchValue={locationSearchQuery}
      defaultValue={null}
      placeholder={'Search by location'}
      dataToDisplay={stores}
      loadingLabel={'Searching Locations...'}
      searchResultsComponent={<StoreSearchResults stores={stores} />}
      noDataMessageComponent={
        <NoResultsWrapper key={'noStoresFound'}>
          <Title>No stores found</Title>
          <NoStoreSearchResults brandName={brandName} />
        </NoResultsWrapper>
      }
    />
  );
};

export default DTRBIStoreLocationSearchNode;
